import SocialShare from './SocialShare';

export default SocialShare;
